import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../auth/Context/AuthContext';
import axios from '../../adapters/API/axios';
import Swal from 'sweetalert2';
import { ActionIcon, Box, Flex } from '@mantine/core';
import { BsPrinter } from 'react-icons/bs';
import ExportExcel from '../../component/ExportExcel';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';
import ModalDetailLokasiVisit from '../../component/Modal/ModalDetailLokasiVisit';
import { GoInfo } from 'react-icons/go';
import { useMediaQuery } from 'react-responsive';

function DetailAbsenVisitKaryawan() {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { karyawanid } = useParams();
    const { tokens } = useContext(AuthContext);
    const tokenUser = tokens?.token;
    const [userDetail, setUserDetail] = useState();
    const [visitMasuk, setVisitMasuk] = useState([]);
    const [visitKeluar, setVisitKeluar] = useState([]);

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        const fetchData = async () => {
            if (karyawanid !== undefined && tokenUser !== undefined) {

                await fetchUserDetail();
                await fetchListVisitMasuk();
                await fetchListVisitKeluar();

            }
        };

        fetchData();
    }, [karyawanid, tokenUser]);

    const fetchUserDetail = () => {
        axios.get(`api/users/${karyawanid}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setUserDetail(res.data);

            }).catch(err => {
                if (err.response?.status === 401) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                        confirmButtonText: 'Login',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/');
                        }
                    });

                } else (console.log(err))
            })
    };

    const fetchListVisitMasuk = () => {
        axios.get(`/api/visit/visitIn/?user_id=${karyawanid}`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Token ` + tokenUser,
            },
        })
            .then(res => {

                setVisitMasuk(res.data);
            }).catch(err => {
                if (err.response?.status === 401) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                        confirmButtonText: 'Login',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/');
                        }
                    });

                } else (console.log(err))
            })
    };

    const fetchListVisitKeluar = () => {
        axios.get(`/api/visit/visitOut/?user_id=${karyawanid}`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Token ` + tokenUser,
            },
        })
            .then(res => {


                setVisitKeluar(res.data);

            }).catch(err => {
                console.log(err)
            })
    };

    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = visitMasuk.map(({ visitIn_location, ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {
                const mainItem = visitKeluar.find((item) => item.visitOut_time.split('T')[0] === data.visitIn_time.split('T')[0]);
                const visitOutTime = mainItem ? mainItem.visitOut_time : '';
                const visitOutPlace = mainItem ? mainItem.visitOut_place : '';

                return {
                    ...data,
                    visit_out_time: visitOutTime,
                    visit_out_place: visitOutPlace,
                };
            })
        );
    }, [visitMasuk, visitKeluar]);

    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (dataTable && dataTable.length > 0) {
            const dataTableFilter = dataTable.map(({ ...rest }) => rest);

            setRowData(
                dataTableFilter.map((data) => {
                    const datePartsCheckin = data?.visitIn_time.split('T')[0].split('-');
                    const yearCheckin = Number(datePartsCheckin[0]);
                    const monthCheckin = Number(datePartsCheckin[1]) - 1;
                    const dayCheckin = Number(datePartsCheckin[2]);

                    const datePartsCheckout = data?.visit_out_time.split('T')[0].split('-');
                    const yearCheckout = Number(datePartsCheckout[0]);
                    const monthCheckout = Number(datePartsCheckout[1]) - 1;
                    const dayCheckout = Number(datePartsCheckout[2]);

                    return {
                        ...data,
                        dateCheckin: new Date(yearCheckin, monthCheckin, dayCheckin),
                        dateCheckout: new Date(yearCheckout, monthCheckout, dayCheckout),
                    };
                })
            );
        }
    }, [dataTable]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const cellDate = new Date(cellValue.getFullYear(), cellValue.getMonth(), cellValue.getDate());

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };

    const [showDetailLokasiVisit, setShowDetailLokasiVisit] = useState(false);
    const [rowSelected, setRowSelected] = useState()
    const handleShowModal = (row) => {
        setShowDetailLokasiVisit(true);
        setRowSelected(row)
    }

    const colDefs = [
        {
            field: "detail",
            headerName: 'Detail',
            width: 120,
            pinned: 'left',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowModal(row?.data)}
                    >
                        <GoInfo
                            size={20}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                );
            },
        },
        {
            field: "dateCheckin",
            headerName: "Tanggal Masuk",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const dateCheckin = params.value;
                if (dateCheckin instanceof Date && !isNaN(dateCheckin)) {
                    const day = String(dateCheckin.getDate()).padStart(2, '0');
                    const month = String(dateCheckin.getMonth() + 1).padStart(2, '0');
                    const year = dateCheckin.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "dateCheckout",
            headerName: "Tanggal Pulang",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const dateCheckout = params.value;
                if (dateCheckout instanceof Date && !isNaN(dateCheckout)) {
                    const day = String(dateCheckout.getDate()).padStart(2, '0');
                    const month = String(dateCheckout.getMonth() + 1).padStart(2, '0');
                    const year = dateCheckout.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "jam",
            headerName: 'Jam Visit Masuk',
            cellRenderer: (row) => {
                const checkinTime = row?.data?.visitIn_time;
                const formattedTime = checkinTime ? checkinTime.split('T')[1].split('.')[0] : '';

                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {formattedTime}
                    </div>
                );
            },
        },
        {
            field: "jam",
            headerName: 'Jam Visit Keluar',
            cellRenderer: (row) => {
                const checkoutTime = row?.data?.visit_out_time;
                const formattedTimeOut = checkoutTime ? checkoutTime.split('T')[1].split('.')[0] : '';

                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {formattedTimeOut}
                    </div>
                );
            },
        },
        {
            field: "visitIn_place",
            headerName: 'Lokasi Visit Masuk',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.visitIn_place}
                    </div>
                );
            },
        },
        {
            field: "visit_out_place",
            headerName: 'Lokasi Visit Keluar',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.visit_out_place}
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const gridRef = useRef(null);

    const handleExportRowsExcelData = () => {
        if (!gridRef.current) return [];

        const filteredRows = [];
        gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            if (node.data) {
                filteredRows.push(node.data);
            }
        });

        const excelData = filteredRows.map((row) => ({
            'Tanggal Visit Masuk': row?.visitIn_time ? row.visitIn_time.split('T')[0] : '',
            'Tanggal Visit Keluar': row?.visit_out_time ? row.visit_out_time.split('T')[0] : '',
            'Jam Visit Masuk': row?.visitIn_time ? row.visitIn_time.split('T')[1].split('.')[0] : '',
            'Jam Visit Keluar': row?.visit_out_time ? row.visit_out_time.split('T')[1].split('.')[0] : '',
            'Lokasi Visit Masuk': row.visitIn_place,
            'Lokasi Visit Keluar': row.visit_out_place,
        }));


        return excelData;
    };

    const handlePrint = () => {
        navigate('/report-visit-detail-karyawan', { state: { dataTable: dataTable, user_name: userDetail?.first_name + " " + userDetail?.last_name } });
    };

    return (
        <>
            <Container className='mt-4'>
                <Row>
                    <Col xs={6} md={11} className='my-auto'>
                        <h1 className='display-6 text-start' style={{ fontFamily: 'Poppins-Light' }} >Detail Visit</h1>

                    </Col>
                    <Col xs={6} md={1} className='text-end'>
                        <Button
                            onClick={handleBack}
                            variant='btn'
                            style={{ minHeight: '50px', backgroundColor: '#696969', color: 'white', fontFamily: 'Poppins-Regular' }}
                        >
                            Kembali
                        </Button>
                    </Col>
                </Row>
            </Container>
            <h3 className='text-center mt-3' style={{ fontFamily: 'Poppins-Regular' }}>{userDetail?.first_name} {userDetail?.last_name}</h3>
            <Container fluid className='mt-5'>
                <Box>
                    {/* Top Toolbar */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '16px',
                            padding: '8px',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Flex gap="xs" align="center">
                            <ActionIcon onClick={handlePrint}>
                                <BsPrinter style={{ backgroundColor: 'transparent', color: '#222' }} size={40} />
                            </ActionIcon>
                            <ActionIcon>
                                <ExportExcel
                                    getExcelData={handleExportRowsExcelData}
                                    fileName={`Report Visit Detail ${userDetail?.first_name} ${userDetail?.last_name}`}
                                />
                            </ActionIcon>
                        </Flex>
                    </Box>
                    <div style={{ height: 500 }}>

                        <AgGridReact
                            theme={themeLightCold}
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={colDefs}
                            defaultColDef={defaultColDef}
                            pagination={isMobile ? false : true}
                            rowHeight={25}
                        />

                    </div>

                    <ModalDetailLokasiVisit
                        rowSelected={rowSelected}
                        showDetailLokasiVisit={showDetailLokasiVisit}
                        setShowDetailLokasiVisit={setShowDetailLokasiVisit}
                    />
                </Box>
            </Container>
        </>
    )
}

export default DetailAbsenVisitKaryawan
